import { DEFAULT_MODULE_LENGTH } from '../../consts';
import { Wrapper, BigTile, SmallTile } from './styles';

const VisualLayout = ({ nrOfFrames, numOfProjects: numOfModules = 9, projectLength: moduleLength = DEFAULT_MODULE_LENGTH, wrapperStyles = {}, id = '' , isManifold = false}) => {
  if (nrOfFrames) {
    numOfModules = Math.round(nrOfFrames / moduleLength);
  }
  return (
    <Wrapper
      style={wrapperStyles}
      id={id}>
      {[...new Array(numOfModules)].map((_, index) => (
        <BigTile key={index}>
          {[...new Array(moduleLength)].map((_, index) => (
            <SmallTile key={index} isManifold={isManifold}></SmallTile>
          ))}
        </BigTile>
      ))}
    </Wrapper>
  );
};

export default VisualLayout;
